


import { PackagesController } from './controllers/packagesController';
import '../../models/requestPackages';
import '../../../../../core/directives/readOnlyText/readOnlyTextDirective';


import '../packageDialog/controllers/packageDialogController';

export class PackagesDirective implements angular.IDirective {
    template = require('./templates/packages.html');
    restrict = 'E';
    controller = PackagesController;
    controllerAs = 'vm';
    bindToController = {
        requestDetailEdit:"=",
        isFormRequestedFromAddNewRequest: '=',
        isValid : '='
    };
    scope = {};
    replace = true;
    static factory(): angular.IDirectiveFactory {
        return () => new PackagesDirective();
    }
}

angular.module('deliveryCreate.app').directive('packages', PackagesDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/packages/packagesDirective.ts
 **/